import{unstable_useIsFocusVisible as _0x4e5908}from'@mui/utils';export default _0x4e5908;